import React from "react";

interface IProps {
  label: string;
  isDisabled?: boolean;
  onPress?: () => Promise<void> | void | null;
  type: "button" | "submit" | "reset";
  mode: "prev" | "next" | "done" | "action";
  hackWidth?: boolean | undefined;
  className?: string;
}

export const ZeosButton = (props: IProps) => {
  const { label, isDisabled, onPress, type, mode, hackWidth, className } =
    props;

  const baseClasses = `
    font-light text-[1.125rem] transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-offset-2
    font-sans
    whitespace-nowrap
  `;

  let modeClasses = "";
  const hasColorOverride =
    Boolean(className) && (mode === "done" || mode === "next" || mode === "action");
  const actionColorClasses = hasColorOverride
    ? className!
    : `
        bg-zeos-orange-dk text-white
        hover:bg-orange-600
        disabled:bg-orange-300
        focus:ring-zeos-orange-dk
      `;
  const extraClasses = hasColorOverride ? "" : className ?? "";

  switch (mode) {
    case "done":
    case "next":
    case "action":
      modeClasses = `
        flex items-center justify-center
        ${actionColorClasses}
        ${hackWidth ? "w-full" : "w-auto"} 
        h-[2.34375rem]
        rounded-[0.5rem] px-4 
        disabled:cursor-not-allowed 
      `;
      break;

    case "prev":
      modeClasses = `
        text-zeos-orange-dk 
        hover:underline 
        text-[1.125rem]
        px-2 
        disabled:text-orange-300 
        focus:ring-zeos-orange-dk
      `;
      break;
  }

  return (
    <button
      disabled={isDisabled}
      type={type}
      onClick={onPress || undefined}
      className={`${baseClasses} ${modeClasses} ${extraClasses}`}
    >
      {label}
    </button>
  );
};
